import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const NoteList: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31572)'>
        <path
          d='M20.3315 2.2396H15.4384V1.59125C15.4384 1.26524 15.1753 1 14.8518 1H10.0664C9.74295 1 9.47976 1.26524 9.47976 1.59125V2.2396H4.58668C4.26318 2.2396 4 2.50483 4 2.83085V22.4088C4 22.7348 4.26318 23 4.58668 23H20.3315C20.655 23 20.9182 22.7348 20.9182 22.4088V2.83085C20.9182 2.50483 20.655 2.2396 20.3315 2.2396ZM10.3115 1.83823H14.6067V3.47917H10.3115V1.83823ZM20.0864 22.1618H4.83175V3.07783H9.47976V3.72615C9.47976 4.05216 9.74295 4.3174 10.0664 4.3174H14.8518C15.1753 4.3174 15.4384 4.05216 15.4384 3.72615V3.07783H20.0864V22.1618Z'
          fill='url(#paint0_linear_12280_31572)'
          stroke='url(#paint1_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M6.8523 14.2744H10.0319C10.3554 14.2744 10.6185 14.0092 10.6185 13.6832V11.5483C10.6185 11.2223 10.3554 10.957 10.0319 10.957H6.8523C6.52881 10.957 6.26562 11.2223 6.26562 11.5483V13.6832C6.26562 14.0092 6.52881 14.2744 6.8523 14.2744ZM7.09737 11.7953H9.78679V13.4362H7.09737V11.7953Z'
          fill='url(#paint2_linear_12280_31572)'
          stroke='url(#paint3_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M12.2518 7.29297C12.0221 7.29297 11.8359 7.48062 11.8359 7.71208C11.8359 7.94355 12.0221 8.1312 12.2518 8.1312H18.0426C18.2723 8.1312 18.4585 7.94355 18.4585 7.71208C18.4585 7.48062 18.2723 7.29297 18.0426 7.29297H12.2518Z'
          fill='url(#paint4_linear_12280_31572)'
          stroke='url(#paint5_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M18.0426 12.1953H12.2518C12.0221 12.1953 11.8359 12.383 11.8359 12.6144C11.8359 12.8459 12.0221 13.0335 12.2518 13.0335H18.0426C18.2723 13.0335 18.4585 12.8459 18.4585 12.6144C18.4585 12.383 18.2723 12.1953 18.0426 12.1953Z'
          fill='url(#paint6_linear_12280_31572)'
          stroke='url(#paint7_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M18.0426 17.1055H12.2518C12.0221 17.1055 11.8359 17.2931 11.8359 17.5246C11.8359 17.7561 12.0221 17.9437 12.2518 17.9437H18.0426C18.2723 17.9437 18.4585 17.7561 18.4585 17.5246C18.4585 17.2931 18.2723 17.1055 18.0426 17.1055Z'
          fill='url(#paint8_linear_12280_31572)'
          stroke='url(#paint9_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M10.0715 6.42315L7.92794 8.08866L6.99515 7.00899C6.84433 6.83444 6.58163 6.81613 6.40841 6.96813C6.23519 7.12012 6.21704 7.38485 6.36786 7.55943L7.46689 8.8315C7.57769 8.95976 7.73424 9.02612 7.89199 9.02612C8.01233 9.02612 8.13336 8.98751 8.23529 8.90829L10.5793 7.087C10.7612 6.94566 10.795 6.68248 10.6548 6.49917C10.5145 6.31585 10.2534 6.28182 10.0715 6.42315Z'
          fill='url(#paint10_linear_12280_31572)'
          stroke='url(#paint11_linear_12280_31572)'
          strokeWidth='0.7'
        />
        <path
          d='M10.0715 16.2396L7.92795 17.9051L6.99515 16.8254C6.84432 16.6508 6.58163 16.6325 6.40841 16.7845C6.23519 16.9365 6.21704 17.2013 6.36786 17.3758L7.46689 18.6479C7.57769 18.7762 7.73425 18.8425 7.89199 18.8425C8.01233 18.8425 8.13336 18.8039 8.23529 18.7247L10.5793 16.9034C10.7612 16.7621 10.795 16.4989 10.6548 16.3156C10.5145 16.1323 10.2534 16.0982 10.0715 16.2396Z'
          fill='url(#paint12_linear_12280_31572)'
          stroke='url(#paint13_linear_12280_31572)'
          strokeWidth='0.7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31572'
          x1='7.50337'
          y1='2.50015'
          x2='18.9622'
          y2='20.1618'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31572'
          x1='7.50337'
          y1='2.50015'
          x2='18.9622'
          y2='20.1618'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_31572'
          x1='7.16701'
          y1='11.1832'
          x2='8.42418'
          y2='14.4895'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_31572'
          x1='7.16701'
          y1='11.1832'
          x2='8.42418'
          y2='14.4895'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_31572'
          x1='13.2073'
          y1='7.35013'
          x2='13.2675'
          y2='8.30253'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_31572'
          x1='13.2073'
          y1='7.35013'
          x2='13.2675'
          y2='8.30253'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_31572'
          x1='13.2073'
          y1='12.2525'
          x2='13.2675'
          y2='13.2049'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_31572'
          x1='13.2073'
          y1='12.2525'
          x2='13.2675'
          y2='13.2049'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_31572'
          x1='13.2073'
          y1='17.1626'
          x2='13.2675'
          y2='18.115'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_31572'
          x1='13.2073'
          y1='17.1626'
          x2='13.2675'
          y2='18.115'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_31572'
          x1='7.19243'
          y1='6.51938'
          x2='8.0368'
          y2='9.33494'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_31572'
          x1='7.19243'
          y1='6.51938'
          x2='8.0368'
          y2='9.33494'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_31572'
          x1='7.19243'
          y1='16.3358'
          x2='8.03679'
          y2='19.1513'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_31572'
          x1='7.19243'
          y1='16.3358'
          x2='8.03679'
          y2='19.1513'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31572'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteList;
